import React from 'react';

/** The one refresh control for the admin operation screens (All Orders, Print Batches, Order Recovery). */
const RefreshButton: React.FC<{ onClick: () => void; loading?: boolean; className?: string }> = ({ onClick, loading, className }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={loading}
    title="Refresh"
    className={`inline-flex items-center gap-1 text-sm font-semibold text-storyblue border border-gray-300 rounded-md px-3 py-1.5 hover:bg-gray-100 disabled:opacity-50 ${className || ''}`}
  >
    <span className={loading ? 'inline-block animate-spin' : 'inline-block'} aria-hidden>
      ↻
    </span>
    Refresh
  </button>
);

export default RefreshButton;
